export const normalizeVocabularyText = (value) =>
  String(value || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ")
    .trim();

export const findVocabularyConceptIri = (
  inputValue,
  vocabularyList,
  { lang, fallbackToInput = false } = {},
) => {
  if (!inputValue) return "";

  const normalizedInput = normalizeVocabularyText(inputValue);
  const items = Array.isArray(vocabularyList) ? vocabularyList : [];

  const match = items.find((item) => {
    const localizedLabel = lang ? item?.langName?.[lang] : null;
    const allLocalizedLabels =
      item?.langName && typeof item.langName === "object"
        ? Object.values(item.langName)
        : [];
    const candidates = [
      item?.langName?.eng,
      localizedLabel,
      ...allLocalizedLabels,
      item?.label,
      item?.code,
      item?.concept_iri,
    ]
      .filter(Boolean)
      .map(normalizeVocabularyText);

    return candidates.includes(normalizedInput);
  });

  if (match?.concept_iri) return match.concept_iri;
  return fallbackToInput ? inputValue : "";
};

export function resolveControlledCode(selectedValue, options = []) {
  if (!selectedValue) return selectedValue;

  const normalizedInput = normalizeVocabularyText(selectedValue);

  const match = options.find(
    (item) =>
      [
        item?.concept_iri,
        item?.code,
        item?.label,
        ...(item?.langName && typeof item.langName === "object"
          ? Object.values(item.langName)
          : []),
      ]
        .filter(Boolean)
        .map(normalizeVocabularyText)
        .includes(normalizedInput),
  );

  return match?.code ?? selectedValue;
}
